import Vue from 'vue';
import Router from 'vue-router';

import store from '../store/store';

import { getDefaultPathObject, registerFirstNavigation } from './middleware/middleware';

import Home from '../components/home/Home';

import authRoutes from './auth/routes';
import gameRoutes from './game/routes';
import bladeRoutes from './blade/routes';
import dashboardRoutes from './dashboards/routes';
import supportRoutes from './support/routes';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes: [
    { path: '/', component: Home, meta: { useSignInForNavbar: true } },
    ...authRoutes,
    ...gameRoutes,
    ...bladeRoutes,
    ...dashboardRoutes,
    ...supportRoutes,
  ]
});

router.home = () => {
  const { path, replace } = getDefaultPathObject();
  if (replace) router.replace({ path });
  else router.push({ path });
};

router.nextGameState = async(options) => {
  const { replace, route } = options || {};
  const { entryState, updateGroup, group: { _id: groupId } } = store.getters;

  if (updateGroup && groupId) {
    try {
      await store.dispatch('getMyGroup', { groupId });
    } catch (err) {
      if (await router.handleGameError(err)) return;
      return router.showGameErrorCritical();
    }
  }

  const nextState = route || entryState;
  if (replace) return router.replace(nextState);
  router.push(nextState);
};

router.showGameErrorCritical = () => {
  console.trace();
  const { errorState } = store.getters;
  router.replace(errorState);
};

// @returns Boolean true if critical error
router.handleGameError = async(err) => {
  // no server response
  if (!err || !err.response) {
    router.showGameErrorCritical();
    return true;
  }
  // logged out
  await Vue.nextTick();

  const { hasAuthToken } = store.getters;
  if (!hasAuthToken) {
    const message = 'Your session has expired. Please sign in again.';
    store.dispatch('flashDanger', { message });
    router.replace('/signin');
    return true;
  }

  return false;
};

let firstNavigation = true;

const onFirstNavigation = async(next, to) => {
  registerFirstNavigation();
  firstNavigation = false;

  const { dispatch, getters } = store;
  await dispatch('initializeAnonymousAuthParams');
  await dispatch('initializeLtiParams');
  await dispatch('populateAuthToken');

  if (!getters.hasAuthToken) {
    const tgPath = to.path;
    if ((to.meta && to.meta.allowFirstRoute) || tgPath.startsWith('/signin')) return next();
    return next({ path: '/signin', replace: true });
  }

  try {
    await dispatch('renewAuthToken');
    if (!getters.me.eulaAccepted && !getters.isLti) {
      dispatch('logout');
      next({ path: '/signin', replace: true });
    } else {
      if (to.meta.allowFirstRoute && !(to.meta.forceFirstRoute)) {
        return next({ path: '/', replace: true });
      }
      next();
    }
  } catch (_) {
    // eslint-disable-next-line no-alert
    alert('Your session has expired. Please log in again.');
    dispatch('logout');
    next({ path: '/signin', replace: true });
  }
};

router.beforeEach((to, from, next) => {
  const { dispatch, getters } = store;
  if (!(to.meta && to.meta.allowFirstRoute) && (getters.authToken && !(getters.me.eulaAccepted)) && !(getters.isLti)) {
    dispatch('logout');
    return next({ path: '/signin', replace: true });
  }

  if (to.path.includes('recurrence')) {
    return next({ path: to.path.replace(/recurrence/gi, 'blade'), replace: true });
  }

  if (!firstNavigation) return next();
  onFirstNavigation(next, to, from);
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js